import { render, staticRenderFns } from "./app-aside.vue?vue&type=template&id=4fd1d15c&scoped=true&"
import script from "./app-aside.vue?vue&type=script&lang=ts&"
export * from "./app-aside.vue?vue&type=script&lang=ts&"
import style0 from "./app-aside.vue?vue&type=style&index=0&id=4fd1d15c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd1d15c",
  null
  
)

export default component.exports